import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Alert } from "@mui/material";

import { useAuth } from "hooks";
import AppConfirmDialog from "components/Shared/AppConfirmDialog";
import { BaseTextField } from "components/FormBuilder/fields/BaseTextField";
import { formHookInputHelper } from "utils/formHookField";
import { useDeleteMyAccountMutation } from "store/services/userApi";

export const ConfirmDeleteMyAccount = React.forwardRef(({ reason }, ref) => {
  const [showConfirm, setShowConfirm] = React.useState(false);

  const { logout } = useAuth();

  const { control, handleSubmit, setError, reset } = useForm({
    defaultValues: { password: "" },
  });

  const [deleteMyAccount, { isLoading: deletingAccount }] =
    useDeleteMyAccountMutation();

  // methods
  const handleToggleConfirmation = () => {
    setShowConfirm((prev) => !prev);
    reset({ password: "" });
  };

  const handleSoftDelete = async (data) => {
    try {
      await deleteMyAccount(data).unwrap();
      logout();
    } catch (err) {
      setError("password", {
        type: "manual",
        message: err?.data?.message ?? "Couldn't delete account!",
      });
    }
  };

  React.useImperativeHandle(ref, () => ({
    handleToggleConfirmation,
  }));

  return (
    <AppConfirmDialog
      open={showConfirm}
      onConfirm={handleSubmit(handleSoftDelete)}
      onClose={handleToggleConfirmation}
      loading={deletingAccount}
      hideIcon
    >
      <div className="grid gap-4">
        <Alert severity="warning">
          Provide your password to confirm deletion.
        </Alert>

        <Controller
          name="password"
          control={control}
          rules={{ required: "Please provide your password." }}
          render={(props) => (
            <BaseTextField
              {...formHookInputHelper(props)}
              fullWidth
              required
              label="Password"
              type="Password"
              autoComplete="new-password"
            />
          )}
        />
      </div>
    </AppConfirmDialog>
  );
});
